import { FilterFacet } from './Toolbar';
import { useSelector } from 'react-redux';

interface RootState {
  app: {
    context: {
      locale: string;
    };
  };
}

export const useFacetTitle = (facet) => {
  const locale = useSelector((state: RootState) => state.app.context.locale);
  if (!['range', 'term'].includes(facet.type)) {
    return null;
  }

  if (facet.type === 'term' && (!facet.terms || facet.terms.length === 0)) return null;
  if (facet.type === 'range' && !(facet.max || facet.min)) return null;

  if (facet.attributeId === 'variants.attributes.primarycategory') {
    return 'Category';
  }
  return facet?.label[locale] || facet?.label['en_AU@AUD'] || 'No luck';
};
